<template>
    <footer class="footer mt-auto py-2">
        <div class="container text-center">
            <small class="text-muted"><b>Powered by:</b><a href="https://sait.mx/" class="text-muted" target="_blank" > SAIT® - Software Administrativo y Contable</a></small>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
    }
</script>
<style>
    .footer{
        background-color: #f5f5f5;
    }
</style>


